// src/components/GuestDetailModal.jsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  Box,
  Typography
} from '@mui/material';
import { BadgeCheck, Phone, Building, Heart } from 'lucide-react';

export default function GuestDetailModal({ guest, onClose }) {
  const [tab, setTab] = React.useState(0);

  const { identity, contact, business } = guest.profile || {};
  const { stayPreferences } = guest;

  return (
    <Dialog
      open={!!guest}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          height: 520, // Fixed vertical height in pixels
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <DialogTitle>{guest.fullName || 'Guest Detail'}</DialogTitle>
      <DialogContent sx={{ py: 3, px: 4 }}>
        <Tabs value={tab} onChange={(e, newVal) => setTab(newVal)} variant="scrollable" scrollButtons="auto">
          <Tab icon={<BadgeCheck size={18} />} iconPosition="start" label="Identity" />
          <Tab icon={<Phone size={18} />} iconPosition="start" label="Contact" />
          <Tab icon={<Building size={18} />} iconPosition="start" label="Business" />
          <Tab icon={<Heart size={18} />} iconPosition="start" label="Preferences" />
        </Tabs>

        {tab === 0 && identity && (
          <Box p={2}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Title:</strong> {identity.title}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Full Name:</strong> {identity.fullName}
            </Typography>
            
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Nationality:</strong> {identity.nationality}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Date of Birth:</strong> {identity.dob}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Place of Birth:</strong> {identity.placeOfBirth}
            </Typography>
            
          </Box>
        )}

        {tab === 1 && contact && (
          <Box p={2}>
            
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Phone:</strong>{contact.countryCode} {contact.phone}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Address:</strong> {contact.address}
            </Typography>
            
          </Box>
        )}

        {tab === 2 && business && (
          <Box p={2}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Email:</strong> {business.businessEmail}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
                
              <strong>Phone: </strong> {contact.countryCode} {business.businessPhone}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Business Address:</strong> {business.businessAddress}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Billing Address:</strong> {business.billingAddress}
            </Typography>
          </Box>
        )}

        {tab === 3 && stayPreferences && (
          <Box p={2}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Dining:</strong> {stayPreferences.diningPrefs?.join(', ')}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Interests:</strong> {stayPreferences.interestPrefs?.join(', ')}
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Room:</strong> {stayPreferences.roomPrefs?.join(', ')}
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}